module.exports = __webpack_public_path__ + "media/application/images/svgs/navigation-2-f236bc1cf581278ca6bbb8d801545355.svg";